var $name="setCSSVariable",$path="app/utilities/setCSSVariable.js",$this={$name,$path,};import validateCSSVariable from './validateCSSVariable';

function setCSSVariable(name, value, element = document.documentElement) {
  validateCSSVariable(name);
  element?.style?.setProperty(name, value);
}

export default setCSSVariable;
